import { render, staticRenderFns } from "./semantic-match-feature-container.component.vue?vue&type=template&id=1d5974d8&scoped=true"
import script from "./semantic-match-feature-container.component.vue?vue&type=script&lang=ts"
export * from "./semantic-match-feature-container.component.vue?vue&type=script&lang=ts"
import style0 from "./semantic-match-feature-container.component.vue?vue&type=style&index=0&id=1d5974d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5974d8",
  null
  
)

export default component.exports